import React from "react";
import PropTypes from "prop-types";
import DistribuicaoGoldenStoresDesktop from "./DistribuicaoGoldenStoresDesktop";

function DistribuicaoGoldenStores({ app, config }) {
  return <DistribuicaoGoldenStoresDesktop app={app} config={config} />;
}

DistribuicaoGoldenStores.defaultProps = {
  app: null,
  config: {},
};

DistribuicaoGoldenStores.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default DistribuicaoGoldenStores;
